import { PanelBreakpointInstance } from '~/panel_breakpoint_instance';
import { toggleWikiSidebar } from '~/wikis/utils/sidebar_toggle';
import { observeSidebarResponsiveness } from '~/wikis/utils/sidebar_responsive';
import WikiSidebarHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sidebar_header.vue?vue3';
import WikiSidebarEntries from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sidebar_entries.vue?vue3';
const LOCAL_STORAGE_STATE_KEY = 'wiki-sidebar-expanded';
const sidebarExpandedByDefault = ()=>{
    return PanelBreakpointInstance.getBreakpointSize() === 'xl';
};
export default {
    name: 'WikiSidebar',
    components: {
        WikiSidebarHeader,
        WikiSidebarEntries
    },
    inject: [
        'hasCustomSidebar'
    ],
    data () {
        return {
            initialExpandedState: JSON.parse(localStorage.getItem('wiki-sidebar-open')) ?? sidebarExpandedByDefault(),
            pagesListExpanded: this.getInitialPagesListState()
        };
    },
    computed: {
        initialClasses () {
            return this.initialExpandedState ? 'sidebar-expanded' : 'sidebar-collapsed';
        }
    },
    watch: {
        pagesListExpanded (newValue) {
            this.persistPagesListState(newValue);
        }
    },
    mounted () {
        this.cleanupResponsiveObserver = observeSidebarResponsiveness(()=>{
            toggleWikiSidebar(false);
        });
    },
    beforeDestroy () {
        if (this.cleanupResponsiveObserver) {
            this.cleanupResponsiveObserver();
        }
    },
    methods: {
        getInitialPagesListState () {
            // If no custom sidebar, always show pages list
            if (!this.hasCustomSidebar) return true;
            // Restore from localStorage if available
            const savedState = localStorage.getItem(LOCAL_STORAGE_STATE_KEY);
            return savedState === 'expanded';
        },
        persistPagesListState (expanded) {
            if (expanded) {
                localStorage.setItem(LOCAL_STORAGE_STATE_KEY, 'expanded');
            } else {
                localStorage.removeItem(LOCAL_STORAGE_STATE_KEY);
            }
        }
    }
};
